import { Card } from "@components/common/ui/Card";
import { Heading } from "@components/common/ui/Heading";
import { styled } from "@styles";
import { fadeInFromTop } from "@styles/animations";

export const Container = styled("main", {
  overflow: "auto",
  width: "100%",
  height: "100vh",
  background: "$neutral00",
});

export const ScrollableContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "0 $8px",
});

export const ContentCard = styled(Card, {
  padding: "$24px $32px",
  marginBottom: "$48px",
  maxWidth: "$1150px",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  opacity: 0,
  animation: `${fadeInFromTop} 0.5s ease-in-out`,
  animationFillMode: "forwards",
  animationDelay: "0.7s",
  variants: {
    flex: {
      true: {
        flexDirection: "row",
        "@md": {
          flexWrap: "wrap",
          justifyContent: "center",
        },
      },
    },
    alignItems: {
      start: {
        alignItems: "flex-start",
      },
      end: {
        alignItems: "flex-end",
      },
    },
    justifyContent: {
      start: {
        justifyContent: "flex-start",
      },
      center: {
        alignItems: "center",
      },
      end: {
        alignItems: "flex-end",
      },
    },
    wrap: {
      true: {
        flexWrap: "wrap",
      },
    },
    noMarginBottom: {
      true: {
        marginBottom: "0",
      },
    },
    small: {
      true: {
        padding: "$16px",
        maxWidth: "$400px",
        minWidth: "fit-content",
        marginBottom: "0",
      },
    },
  },
});

export const Title = styled(Heading, {
  maxWidth: "$600px",
  "@md": {
    textAlign: "center",
  },
});

export const SubTitle = styled("h3", {
  maxWidth: "$600px",
  wordBreak: "break-all",
  fontSize: "$20px",
  fontWeight: "semi-bold",
  color: "$neutral70",
  marginBottom: "$24px",
  lineHeight: "$32px",
  margin: "0",
  variants: {
    dark: {
      true: {
        color: "$neutral100",
      },
    },
    margin: {
      small: {
        marginBottom: "$8px",
      },
      none: {
        marginBottom: "0",
      },
    },
  },
});

export const Text = styled("p", {
  wordBreak: "break-all",
  color: "$neutral60",
  fontSize: "$16px",
  lineHeight: "$24px",
  margin: "0",
  variants: {
    bold: {
      true: {
        fontWeight: "$bold",
      },
    },
    semibold: {
      true: {
        fontWeight: "semi-bold",
      },
    },
    small: {
      true: {
        fontSize: "$14px",
      },
    },
    xs: {
      true: {
        fontSize: "$12px",
      },
    },
    light: {
      true: {
        color: "$neutral60",
      },
    },
    dark: {
      true: {
        color: "$neutral90",
      },
    },
    displayMiddle: {
      true: {
        display: "flex",
        alignItems: "center",
        margin: "auto",
      },
    },
  },
});

export const Span = styled("span", {
  color: "$neutral60",
  fontSize: "$16px",
  lineHeight: "$24px",
  variants: {
    bold: {
      true: {
        fontWeight: "bold",
      },
    },
    semibold: {
      true: {
        fontWeight: "semi-bold",
      },
    },
    small: {
      true: {
        fontSize: "$14px",
      },
    },
    blue: {
      true: {
        color: "$blue50",
      },
    },
    spaced: {
      true: {
        marginLeft: "$16px",
        marginRight: "$4px",
      },
    },
  },
});
